<script>
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
export default {
  page: {
    title: 'Thankyou',
    meta: [{ name: 'description', content: 'The Thankyou page.' }],
  },
  mixins: [layout, NavigateMixin],
  mounted() {
    const localthis = this
    window.onpopstate = function (event) {
      if (event) {
        event.preventDefault()
        localthis.$router.go(-2)
      }
    }
  },
}
</script>

<template>
  <v-container>
    <v-row class="mt-4 mrzero">
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="4"
        xl="4"
        :class="$style.paddingclss"
        class="mobiledevice"
        :align="notDesktop ? 'center' : 'start'"
      >
        <div :class="$style.mobilecenter">
          <h3 :class="$style.peerHeading">Thank you!</h3>
          <div :class="$style.text"
            >This helps us to get to know you better and how we can better serve
            your health needs.
          </div>
          <v-btn class="mt-4" :class="$style.btnClass" @click="$router.go(-2)"
            >Return to dashboard</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.paddingclss {
  padding-left: 40px !important ;
}
.btnClass {
  width: 240px;
  padding: 26px !important;
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
  text-transform: inherit;
  letter-spacing: inherit;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
.peerHeading {
  font-size: 28px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}
.text {
  width: 80%;
  margin: 10px 0 0;
  font-size: 15px;
  line-height: 22.5px !important;
  color: #2c3a4b;
}
@media screen and (max-width: 1263px) {
  .paddingclss {
    padding-left: 0 !important ;
  }
  .text {
    width: 100%;
  }
}

@media screen and (max-width: 959px) {
  .paddingclss {
    padding: 0 20px !important ;
  }
}

@media screen and (max-width: 767px) {
  .paddingclss {
    position: relative;
    height: 85vh;
  }

  .mobilecenter {
    position: absolute;
    top: 50%;
    width: 90%;
    margin: 0;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
}
@media screen and (max-width: 680px) {
  .btnClass {
    width: 100%;
  }
}
</style>

<style scoped>
/deep/ .mt-4.mrzero {
  margin-top: 0 !important;
}
</style>
